import {constructElliptic, generateKeyPair} from "eosjs/dist/eosjs-key-conversions";
import {binaryToDecimal, KeyType} from "eosjs/dist/eosjs-numeric";
import {PublicKey} from "eosjs/dist/eosjs-jssig";

export function redemptionCodeToPrivateKey (code) {
    const cleanCode = code.replace('-', '').trim().toUpperCase();

    const ec = constructElliptic(KeyType.k1);
    const entropy = ec.hash().update(cleanCode).digest('hex');

    const {privateKey} = generateKeyPair(KeyType.k1, {
        secureEnv: true,
        ecOptions: {entropy, entropyEnc: 'hex'}
    });

    return privateKey.toString();
}

export function publicKeyToPrimaryKey(key) {
    const publicKey = PublicKey.fromString(key);

    const bytes = [publicKey.getType().valueOf(), ...publicKey.key.data];
    const hash = publicKey.ec.hash().update(bytes).digest();

    return binaryToDecimal(hash.slice(0, 8));
}
